import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { objectMapToSelectOptions } from 'core/utils';
import { PricingStrategy } from 'quotes/enums';
import { getPricingStrategyLabels } from 'quotes/utils';

interface IProps {
  label?: string;
  onChange?: (value: PricingStrategy | null) => void;
  disabled?: boolean;
}

export const PricingStrategyFormField = ({ label, onChange, disabled = false }: IProps) => {
  const { t } = useTranslation();
  const { control, errors } = useFormContext();

  const handleOnChange = onChange
    ? (_event: unknown, newValue: PricingStrategy | null) => onChange(newValue)
    : undefined;

  return (
    <FormField
      name="pricingStrategy"
      type={InputType.SELECT}
      inputProps={{
        control,
        error: errors?.pricingStrategy,
        label: label === undefined ? t('labelPricingStrategy') : label,
        options: objectMapToSelectOptions(getPricingStrategyLabels()),
        required: true,
        disabled,
        ...(handleOnChange ? { onChange: handleOnChange } : {}),
      }}
    />
  );
};
